let localStorage = {}
localStorage.setItem = (key, value) => {
  localStorage[key] = value
}
localStorage.getItem = (key) => {
  return localStorage[key]
}

try {
  localStorage = window.localStorage || window.sessionStorage || {}
} catch {
  if (console.info) {
    console.info('Unable to access localStorage')
  }
}

export default localStorage
